export type Action = {
  readonly type: string;
  readonly payload?: any;
};

export const setBrands = (brands: string[]): Action => ({
  type: DealerActionsType.SET_BRANDS as DealerActionsType.SET_BRANDS,
  payload: brands,
});

export const setYears = (years: number[]): Action => ({
  type: DealerActionsType.SET_YEARS as DealerActionsType.SET_YEARS,
  payload: years,
});

export const setModels = (models: string[]): Action => ({
  type: DealerActionsType.SET_MODELS as DealerActionsType.SET_MODELS,
  payload: models,
});

export const setTrims = (trims: string[]): Action => ({
  type: DealerActionsType.SET_TRIMS as DealerActionsType.SET_TRIMS,
  payload: trims,
});

export const resetDealer = (): Action => ({
  type: DealerActionsType.RESET_DEALER as DealerActionsType.RESET_DEALER,
});

export enum DealerActionsType {
  SET_YEARS = '[DEALER] Years Set',
  SET_MODELS = '[DEALER] Models Set',
  SET_TRIMS = '[DEALER] Trims Set',
  RESET_DEALER = '[DEALER] Reset',
  SET_BRANDS = '[DEALER] Brands Set',
}

export type DealerActions = ReturnType<
  typeof setYears | typeof setModels | typeof setTrims | typeof setBrands | typeof resetDealer
>;
